module.exports = __webpack_public_path__ + "static/media/snackbarIcon.11f92ba1.svg";